import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft, Mail } from "lucide-react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";

export default function EmailView() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [email, setEmail] = useState(null);

  useEffect(() => {
    api.get(`/email/message/${id}`).then((r) => setEmail(r.data)).catch((e) => toast.error(apiError(e)));
  }, [id]);

  if (!email) return <p className="p-6 text-muted-foreground font-mono text-sm">LOADING...</p>;

  return (
    <div data-testid="email-view-page" className="p-4">
      <button data-testid="email-back-button" onClick={() => navigate(-1)} className="flex items-center gap-1.5 text-xs uppercase tracking-widest text-muted-foreground tap-btn mb-4">
        <ArrowLeft size={14} /> Back
      </button>
      <div className="bg-[#D9A441]/10 rounded-xl p-3 text-xs text-[#8a6a1f] mb-4 flex items-center gap-1.5">
        <Mail size={13} /> Demo email — once Gmail is connected, this opens the real message in Gmail.
      </div>
      <div className="soft-card p-5 rise-in">
        <p className="overline-label">{email.folder === "sent" ? "Sent Mail" : "Inbox"}</p>
        <h1 className="font-display text-2xl tracking-tight mt-1 leading-tight">{email.subject}</h1>
        <p className="text-xs text-muted-foreground font-mono mt-2 border-b border-border pb-3">
          From: {email.sender}<br />
          {new Date(email.date).toLocaleString()}
        </p>
        <p className="text-sm leading-relaxed mt-3 whitespace-pre-wrap">{email.body}</p>
      </div>
    </div>
  );
}
